import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalBusinessPhoneNumberDocument = gql`
  query SalesPortalBusinessPhoneNumber(
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
  ) {
    businessDetails: getBusinessDetails(
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
    ) {
      phone_number
    }
  }
`;
export function useSalesPortalBusinessPhoneNumberQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalBusinessPhoneNumberQuery,
    Types.SalesPortalBusinessPhoneNumberQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalBusinessPhoneNumberQuery,
    Types.SalesPortalBusinessPhoneNumberQueryVariables
  >(SalesPortalBusinessPhoneNumberDocument, options);
}
export function useSalesPortalBusinessPhoneNumberLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalBusinessPhoneNumberQuery,
    Types.SalesPortalBusinessPhoneNumberQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalBusinessPhoneNumberQuery,
    Types.SalesPortalBusinessPhoneNumberQueryVariables
  >(SalesPortalBusinessPhoneNumberDocument, options);
}
export type SalesPortalBusinessPhoneNumberQueryHookResult = ReturnType<
  typeof useSalesPortalBusinessPhoneNumberQuery
>;
export type SalesPortalBusinessPhoneNumberLazyQueryHookResult = ReturnType<
  typeof useSalesPortalBusinessPhoneNumberLazyQuery
>;
export type SalesPortalBusinessPhoneNumberQueryResult = Apollo.QueryResult<
  Types.SalesPortalBusinessPhoneNumberQuery,
  Types.SalesPortalBusinessPhoneNumberQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalBusinessPhoneNumberQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalBusinessPhoneNumberQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalBusinessPhoneNumberQuery,
    Types.SalesPortalBusinessPhoneNumberQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalBusinessPhoneNumberQuery,
    Types.SalesPortalBusinessPhoneNumberQueryVariables
  >(SalesPortalBusinessPhoneNumberDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalBusinessPhoneNumberLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalBusinessPhoneNumberLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalBusinessPhoneNumberQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalBusinessPhoneNumberQuery,
    Types.SalesPortalBusinessPhoneNumberQueryVariables
  >(SalesPortalBusinessPhoneNumberDocument, lazyOptions);
}
